import axios, { type AxiosResponse } from 'axios';
import type { InterceptedError } from '@/shared/api/intercepted-error';

export const isHtmlResponse = (response: unknown): boolean => {
  const { headers } = (response ?? {}) as Partial<AxiosResponse>;

  return String(headers?.['content-type'] ?? '')
    .toLowerCase()
    .includes('text/html');
};

export const isBackendUnavailable = (error: unknown): boolean => {
  if (axios.isCancel(error)) return false;

  const axiosError = error as InterceptedError | undefined;
  if (!axios.isAxiosError(axiosError)) return false;

  if (!axiosError.response) {
    return axiosError.code !== 'ERR_CANCELED';
  }

  const { status, data } = axiosError.response;
  if (status >= 500 && isHtmlResponse(axiosError.response)) return true;
  if (status === 502 || status === 504) return true;

  return (
    status >= 500 &&
    (data as { type?: string } | null)?.type === 'ServiceUnavailableError'
  );
};